import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./httpInterSeptur/HttpInterSeptur";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { createTheme, ThemeProvider } from "@mui/material";
import { ToastContainer } from "react-toastify";
import { HelmetProvider } from "react-helmet-async";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import "react-toastify/dist/ReactToastify.css"; // import toast styles
// import { FpjsProvider } from '@fingerprintjs/fingerprintjs-pro-react';
// import AntiInspect from './AntiInspect';

const theme = createTheme({
  typography: {
    allVariants: {
      textTransform: "none",
    },
  },
});
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
          toastStyle={{
            color: "#00ff11ff",
            backgroundColor: "#fff",
            fontWeight: 500,
          }}
          toastClassName="custom-toast"
        />

        <HelmetProvider>
          <App />
        </HelmetProvider>
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>
);

serviceWorkerRegistration.register();
reportWebVitals();
